import React, { useEffect, useRef, useState } from "react";
import style from "css/telehealth.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";
import { useDispatch } from "react-redux";
import { openPopup } from "redux/slices/drawerPopupSlice";
import NeatPopup from "components/device/neat/neatPopup";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

function Symposium() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  // const [body, setBody] = useState(1);
  //dispatch
  const dispatch = useDispatch();
  const [info, setInfo] = useState(1);

  const infoBodyList = [
    {
      header: "고품질의 화상 및 음향 제공",
      img: `img/smartspace/symposium1${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt: (
        <font>
          Neat 디바이스는 고해상도 비디오와 탁월한 음향 품질을 제공하여,
          발표자와 청중 간의 명확하고 원활한 소통을 가능하게 합니다. 이는
          세미나의 몰입도를 높이고, 정보 전달의 정확성을 보장합니다.
        </font>
      ),
    },
    {
      header: "편리한 사용과 높은 접근성",
      img: `img/smartspace/symposium2${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt: (
        <font>
          Neat 디바이스는 고해상도 비디오와 탁월한 음향 품질을 제공하여,
          발표자와 청중 간의 명확하고 원활한 소통을 가능하게 합니다. 이는
          세미나의 몰입도를 높이고, 정보 전달의 정확성을 보장합니다.
        </font>
      ),
    },
    {
      header: "글로벌 접근성 및 유연성",
      img: `img/smartspace/symposium3${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt: (
        <font>
          전 세계의 의료 전문가들이 참석하는 세미나에 시간과 장소에 구애받지
          않고 참여할 수 있습니다. 이는 글로벌 의료 커뮤니티와의 네트워킹을
          강화하고, 다양한 시각과 경험을 공유할 수 있는 기회를 제공합니다.
        </font>
      ),
    },
    {
      header: "보안 및 안정성",
      img: `img/smartspace/symposium4${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt: (
        <font>
          Zoom Webinar의 보안 기능과 neat. 제품의 안정적인 하드웨어는
          의료세미나/학술대회 진행 중 발생 할 수 있는 보안 위협을 최소화 합니다.
          이를 통해 발표자와 참가자 모두가 안전하게 세미나에 참여할 수 있습니다.
        </font>
      ),
    },
  ];

  const [infoBody, setInfoBody] = useState(infoBodyList[0]);
  useEffect(() => {
    setInfoBody(infoBodyList[info - 1]);
  }, [info]);

  const scrollContainerRef = useRef(null);

  const handleMouseDown = (e) => {
    const container = scrollContainerRef.current;
    container.isDown = true;
    container.startX = e.pageX - container.offsetLeft;
    container.scrollLeft = container.scrollLeft;
  };

  const handleMouseLeave = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseUp = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseMove = (e) => {
    const container = scrollContainerRef.current;
    if (!container.isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - container.startX) * 0.5; // 스크롤 속도 조절
    container.scrollLeft = container.scrollLeft - walk;
  };

  const ComposeHeader =
    !isMobile && !isTablet ? (
      <div className={style.commonComposeTitle}>
        의료세미나 / 학술대회 <font>구성 환경</font>
      </div>
    ) : (
      <div className={style.commonComposeTitle}>
        의료세미나 / 학술대회
        <br />
        <bold>구성 환경</bold>
      </div>
    );

  const Compose = [
    {
      id: 1,
      img: `img/device/neat/swiper_bar_2${!isMobile && !isTablet ? "" : "_m"}.png`,
      title: "neat. bar pro",
      txt: "Neat Bar Pro는 중대형 회의실에 최적화된 고성능 화상회의 솔루션입니다. 개선된 카메라와 오디오 기능으로 더 선명한 영상과 몰입감 있는 회의를 지원합니다.",
      onClick: () => showDrawer("barpro"),
    },
    {
      id: 2,
      img: `img/device/neat/swiper_center${!isMobile && !isTablet ? "" : "_m"}.png`,
      title: "neat. center",
      txt: "Neat Center는 원격 협진 시 회의실 내 모든 참가자의 음성과 영상을 선명하게 전달할 수 있도록 설계된 스마트 화상회의 장비입니다. 360° 카메라와 16개 마이크 어레이를 통해 회의실 내 모든 발언자를 자동으로 감지하여, 의료진 간 협업이 더욱 자연스럽고 몰입감 있게 진행됩니다.",
      onClick: () => showDrawer("center"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      }),
    );
    document.querySelector("#page_header").style.height = "0";
  };

  return (
    <>
      <SEOMeta
        title="의료 세미나 / 학술대회, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 의료 세미나 / 학술대회"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 텔레헬스, 비대면 진료, 
        스마트 텔레헬스 시스템, 의료 세미나, 학술대회"
      />
      <NeatPopup />
      <div className={style.wrapper}>
        <div className={style.healthTitle}>
          <p>Medical Symposium & Conference</p>
          <p>의료 세미나 / 학술대회</p>
          {!isMobile && !isTablet ? (
            <p>
              의료세미나 및 학술대회를 비대면으로 개최/참여할 수 있습니다.{" "}
              <br />
              시간과 장소의 제약 없이 최신 의료 지식과 연구 결과를 공유하고
              논의할 수 있습니다.
            </p>
          ) : (
            <p>
              의료세미나 및 학술대회를
              <br />
              비대면으로 개최/참여할 수 있습니다.
              <br />
              시간과 장소의 제약 없이
              <br />
              최신 의료 지식과 연구 결과를 공유하고
              <br />
              논의할 수 있습니다.
            </p>
          )}
        </div>
        <div className={style.sympImg}>
          <img
            alt=""
            src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/symposiumImg1${!isMobile && !isTablet ? "" : "_m"}.png`}
          />
        </div>
        {!isMobile && !isTablet ? (
          <div className={style.sympTitle2}>
            <p>
              <font>고해상도 화상회의 기능을 통해 </font>
              <highlight>발표와 토론이 원활하게</highlight> 이루어지며, 실시간
              질문과 답변, 자료 공유 등 다양한 인터랙티브 기능을 지원합니다.
            </p>
            <p>
              또한, 학술대회 참가자들은 전 세계 어디서든 참여할 수 있어,{" "}
              <font>글로벌 의료 커뮤니티의 형상과 협력을 촉진</font>합니다.
            </p>
          </div>
        ) : (
          <div className={style.sympTitle2}>
            <font1>고해상도 화상회의 기능을 통해</font1>
            <br />
            <highlight>발표와 토론이 원활하게</highlight> 이루어지며,
            <br />
            실시간 질문과 답변, 자료 공유 등
            <br />
            다양한 인터랙티브 기능을 지원합니다.
            <br />
            또한, 학술대회 참가자들은
            <br />
            전 세계 어디서든 참여할 수 있어,
            <br />
            <font1>글로벌 의료 커뮤니티의 형상과</font1>
            <br />
            <font1>협력을 촉진</font1>합니다.
          </div>
        )}
        <div
          className={style.healthBody2}
          style={{
            backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/smartspace/teleBackgroundImg${!isMobile && !isTablet ? "" : "2_m"}.png')`,
          }}
        >
          <div className={style.consolutionInfo}>
            {!isMobile && !isTablet ? (
              <div className={style.consolutionInfoHeader}>
                <font>리브테크놀로지의 Telehealth</font>
                <font> 의료세미나 / 학술대회 시스템</font>
              </div>
            ) : (
              <div className={style.consolutionInfoHeader}>
                리브테크놀로지의 Telehealth
                <br />
                <bold>의료세미나 / 학술대회 시스템</bold>
              </div>
            )}
            <div className={style.consolutionInfoTypeList}>
              <div
                onClick={() => {
                  setInfo(1);
                }}
                className={info === 1 ? style.infoOn : style.infoOff}
              >
                {" "}
                고품질의 화상 <br /> 및 음향 제공
              </div>
              <div
                className={info === 2 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(2);
                }}
              >
                편리한 사용과
                <br /> 높은 접근성
              </div>
              <div
                className={info === 3 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(3);
                }}
              >
                글로벌 접근성
                <br /> 및 유연성
              </div>
              <div
                className={info === 4 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(4);
                }}
              >
                보안
                <br /> 및 안정성
              </div>
            </div>
            <div className={style.consolutionInfoBody}>
              <div>
                <img
                  alt=""
                  src={`${process.env.REACT_APP_CLIENT_URL}` + infoBody.img}
                />
              </div>
              <div>
                <font>{infoBody.header}</font>
                {infoBody.txt}
              </div>
            </div>
          </div>
        </div>
        <div className={style.commonCompose}>
          <div className={style.commonCompseBody}>
            {ComposeHeader}

            <Swiper
              scrollbar={{ draggable: true }}
              slidesPerView={"auto"}
              spaceBetween={"4%"}
              modules={[Scrollbar]}
              className={style.commonComposeCardWrap}
              observer={true}
              observeParents={true}
              observeSlideChildren={true}
              grabCursor={true}
            >
              {Compose.map((info, index) => (
                <SwiperSlide className={style.commonComposeCard} key={index}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    <div onClick={info.onClick}>
                      <font>More</font>{" "}
                      <img
                        alt=""
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/smartspace/arrowRight.png"
                        }
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            {/* <div
              className={style.commonComposeCardWrap}
              ref={scrollContainerRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {Compose.map((info) => (
                <div className={style.commonComposeCard}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    <Link
                      to={`${process.env.REACT_APP_CLIENT_URL + info.link}`}
                    >
                      <div>
                        <font>More</font>{" "}
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/arrowRight.png"
                          }
                        />
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div> */}

            <div className={style.commonComposeFooter}>
              <div
                style={{
                  backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/smartspace/composefooterImg${!isMobile && !isTablet ? "" : "_m"}.png')`,
                }}
              >
                <p>
                  <img
                    className={style.bang}
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/bang${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                </p>
                {!isMobile && !isTablet ? (
                  <p>
                    <font>병원 환경에 맞춰</font> 선택하여 구축 가능합니다.
                    상담을 통해 정확히 진단해 보세요.
                  </p>
                ) : (
                  <p>
                    <bold>기업 환경에 맞춰</bold> 선택하여 구축 가능합니다.
                    <br />
                    상담을 통해 정확히 진단해 보세요.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <Questions />
      </div>
    </>
  );
}

export default Symposium;
